var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FB6A66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245 30c-6.629 0-12 5.371-12 12s5.371 12 12 12 12-5.371 12-12-5.371-12-12-12zm6.144 8.683l-7.713 7.748h-.006c-.098.098-.363.317-.67.317-.218 0-.467-.121-.674-.329l-3.231-3.23c-.092-.093-.092-.237 0-.33l1.027-1.026c.046-.046.104-.07.161-.07.058 0 .116.024.162.07l2.562 2.561 7.038-7.09c.046-.046.104-.07.162-.07.063 0 .12.024.161.07l1.01 1.044c.104.098.104.242.011.335z",
    transform: "translate(-965 -283) translate(120 72) translate(610 36) translate(2 145)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.68cbcaa9a8fc12e099bc57436f02aa39.svg";
export { ForwardRef as ReactComponent };